module.exports = "/packs/009-5078a00c766be061d14bceba8ec0b267.jpg";